import { Card } from '@celltrak/ui-components';
import { useHistory } from 'react-router-dom';

import { cardDescription } from '../../constants';

import styles from './SetupContent.module.scss';

const SetupContent = () => {
  const history = useHistory();

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <Card id="agencies-card" title="Agencies" onCardClick={() => history.push('/evv/agencies')}>
          <div className={styles.cardContent}>{cardDescription.agencies}</div>
        </Card>
        <Card
          id="procedure-card"
          title="Procedure Codes"
          onCardClick={() => history.push('/evv/procedure')}
        >
          <div className={styles.cardContent}>{cardDescription.procedureCodes}</div>
        </Card>
        <Card id="reason-card" title="Reason Codes" onCardClick={() => history.push('/evv/reason')}>
          <div className={styles.cardContent}>{cardDescription.reasonCodes}</div>
        </Card>
        <Card id="payers-card" title="Payers" onCardClick={() => history.push('/evv/payers')}>
          <div className={styles.cardContent}>{cardDescription.payers}</div>
        </Card>
        <Card
          id="resolution-card"
          title="Resolution Codes"
          onCardClick={() => history.push('/evv/resolution')}
        >
          <div className={styles.cardContent}>{cardDescription.resolutionCodes}</div>
        </Card>
        <Card id="task-card" title="Task Codes" onCardClick={() => history.push('/evv/task')}>
          <div className={styles.cardContent}>{cardDescription.taskCodes}</div>
        </Card>
        <Card
          id="required-fields-card"
          title="Required Fields"
          onCardClick={() => history.push('/evv/required-fields')}
        >
          <div className={styles.cardContent}>{cardDescription.requiredFields}</div>
        </Card>
        <Card
          id="exception-card"
          title="Exception Codes"
          onCardClick={() => history.push('/evv/exception')}
        >
          <div className={styles.cardContent}>{cardDescription.exceptionCodes}</div>
        </Card>
      </div>
    </div>
  );
};

export default SetupContent;
